/**
 * Two Column Story Cards - video popover iframe lifecycle.
 */

document.querySelectorAll('.two-column-story-cards__video-popover').forEach((popover) => {
  const iframe = popover.querySelector('.two-column-story-cards__video-iframe');
  if (!iframe) {
    return;
  }

  const iframeSrc = iframe.dataset.src || '';
  if (iframeSrc === '') {
    return;
  }

  popover.addEventListener('toggle', (event) => {
    if (event.newState === 'open') {
      iframe.src = iframeSrc;
      return;
    }

    iframe.src = '';
  });
});
